<template>
  <div class="innerButton">
    <NuxtLink
      v-if="type === 'link'"
      :to="link"
      class="button"
      :class="[`button--${variant}`, `button--size-${size}`]"
      :disabled="disabled"
      :target="linkType"
    >
      <slot>
        {{ label }}
      </slot>
    </NuxtLink>
    <button
      v-else
      class="button"
      :class="[`button--${variant}`, `button--size-${size}`]"
      :disabled="disabled"
      :type="type"
      @buttonClick="$emit('click')"
    >
      <slot>
        {{ label }}
      </slot>
    </button>
  </div>
</template>

<script lang="ts" setup>
import './styles.scss';

interface Props {
  type?: 'button' | 'submit' | 'reset' | 'link';
  variant?: 'secondary' | 'primary' | 'white' | 'whatsapp';
  disabled?: boolean;
  label?: string;
  size?: 'xl' | 'l' | 's';
  link?: string | object;
  linkType?: '_blank' | '_self';
}

withDefaults(defineProps<Props>(), {
  type: 'button',
  disabled: false,
  label: '',
  variant: 'primary',
  size: 'xl',
  link: undefined,
  linkType: undefined,
});
</script>

<style scoped>
.innerButton[disabled] {
  pointer-events: none;
}
</style>
